// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"702":"fdc77c7e","926":"060346a7"}[chunkId] + ".chunk.css";
};